import { MotifCard, MotifCardBody, MotifCardHeader } from '@ey-xd/motif-react'
import { MotifTabControl } from '@ey-xd/motif-react/components/tab-navigation'
import MotifTabNavigation from '@ey-xd/motif-react/components/tab-navigation'
import React from 'react'

const WorkspaceHeaderTabs = (props: any) => {
    const {menus, active, setActive} = props;
  return (
    <div>
        <MotifTabNavigation  className="!border-0" defaultActiveKey={active}>
            {menus.map((menu: any, index: number) => {
                return (
                    <MotifTabControl onClick={() => {setActive(index)}} key={index}>
                        {menu}
                    </MotifTabControl>
                )
            
            })}
            {/* <MotifTabControl>
                Overview
            </MotifTabControl>
            <MotifTabControl>
                Chat
            </MotifTabControl>
            <MotifTabControl>
                KPIs
            </MotifTabControl>
            <MotifTabControl>
                Dashboard
            </MotifTabControl>
            <MotifTabControl>
                Report
            </MotifTabControl> */}
        </MotifTabNavigation>
    </div>
  )
}

export default WorkspaceHeaderTabs